(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('DailyLogsReportController', DailyLogsReportController);

    DailyLogsReportController.$inject = ['$window', 'common', 'dataservice', 'carousel.dialog', 'ReportFileBuilder'];
    /* @ngInject */
    function DailyLogsReportController($window, common, dataservice, carouselDialog, reportFileBuilder) {
        var vm = this;
        vm.title = 'Daily Logs Report';
        vm.filters = {
            fromDate: new Date(),
            toDate: new Date()
            
        };
        vm.items = [];
        vm.displayedItems = [].concat(vm.items);
        vm.showAttachment = showAttachment;
        vm.openDatePicker = openDatePicker;
        vm.exportToExcel = exportToExcel;
        vm.exportToPdf = exportToPdf;
        vm.emailPdf = emailPdf;
        vm.generated = false;
        vm.dpStatus = {
            fromDateOpen: false,
            toDateOpen: false
        }
        vm.getSingleItemAnswerText = getSingleItemAnswerText;
        vm.formatDateTimeAnswer = formatDateTimeAnswer;
        vm.generate = generate;
        vm.selectedOnly = selectedOnly;
        vm.emailShowing = false;
        vm.showEmail = showEmail;
        /*
        vm.getHtmlForAuto = getHtmlForAuto; 
        function getHtmlForAuto() {
            var d = moment(vm.filters.fromDate);

            dataservice.getItems('api/DailyLogs/GetHtmlForAuto?dateIso=' + d.format("YYYY-MM-DD")).then(function (response) {
                console.log(response.data);
            });
        }
        */
        activate();

        function activate() {
            vm.filters.forDate = new Date();
            var promises = [getFilters()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function _utcToLocal(input) {
            var local = moment.utc(input).toDate();
            return moment(local).format("MM/DD/YYYY hh:mm A");
        }

        function exportToExcel(id) {

            var allowCompletions = vm.items[0].AllowCompletions;
            var reportTable = "";

            reportTable += '<table class="dailyLogTable responsiveTable table table-condensed table-striped">'
            reportTable += '<thead><tr>';
            reportTable += '<th>Added By</th>';
            reportTable += '<th>Added At</th>';
            reportTable += '<th>Entry Title</th>';
            if (allowCompletions) {
                reportTable += '<th>Last Completion</th>';
            }
            

            var firstEntry = vm.items[0];
            for (var i = 0; i < firstEntry.Questions.length; i++) {
                var q = firstEntry.Questions[i];
                if (q.AnswerType !== 8) {
                    reportTable += "<th>" + q.Question + "</th>";
                }
            }
            reportTable += "</tr>";
            reportTable += "</thead>";
    
            for (var i = 0; i < vm.items.length; i++) {
                var item = vm.items[i];
                reportTable += "<tr>";
                
                reportTable += "<td>" + item.UserName + "</td>";
                reportTable += "<td>" + _utcToLocal(item.DateAddedUtc) + "</td>";
                reportTable += "<td>" + item.Entry + "</td>";
                if (allowCompletions) {
                    if (item.LastCompletion) {
                        reportTable += "<td>" + item.LastCompletion + "<br />by:" + item.CompletedBy + "<br/>at:" + _utcToLocal(item.CompletedAtUtc) + "</td > ";

                    }
                    else {
                        reportTable += "<td>&nbsp;</td>";
                    }
                }
                for (var j = 0; j < item.Questions.length; j++) {
                    var q = item.Questions[j];
                    reportTable += "<td>";
                    switch (q.AnswerType) {
                        case 1:
                        case 2:
                            reportTable += q.Answer;
                            break;
                        case 3:
                        case 5:
                            reportTable += getSingleItemAnswerText(q);
                            break;
                        case 4:
                            for (var jj = 0; jj < q.Items.length; jj++) {
                                if (q.Items[jj].Selected) {
                                    reportTable += q.Items[jj].Description + "\n";
                                }
                            }
                            break;
                        case 6:
                            reportTable += formatDateTimeAnswer(q.Answer, true);
                            break;
                        case 7:
                            reportTable += formatDateTimeAnswer(q.Answer, false);
                            break;

                    }
                    reportTable += "</td>";
                }

                reportTable += "</tr>";
            }
            reportTable += "</table>";

            reportFileBuilder.exportToExcel(_getFileName(''), id, null, reportTable);
        }

        

        function getSingleItemAnswerText(question) {
            var answer = question.Answer;
            for (var i = 0; i < question.Items.length; i++) {
                if (question.Items[i].ID == answer) {
                    return question.Items[i].Description;
                }
            }
            return "";
        }

        function formatDateTimeAnswer(answer, isDate) {
            if (answer) {
                var m = moment(answer);
                if (isDate) {
                    return m.format("L");
                }
                else {
                    return m.format("LT");
                }
            }
            else {
                return "";
            }
        }

        function selectedOnly(item) {
            return item.Selected;
        }

        function _getFileName(ext) {
            var logTypeDesc = "";
            for (var i = 0; i < vm.logTypes.length; i++) {
                if (vm.logTypes[i].ID == vm.filters.LogTypeId) {
                    return vm.logTypes[i].Description + ext;
                }
            }
        }

        var _logReportName = "";

        function exportToPdf(id) {
            var docDefinition = _generatePdf();

            var pdf = pdfMake.createPdf(docDefinition).download(_logReportName);
        }

        function _getBrowser() {
            var userAgent = $window.navigator.userAgent;
            var browsers = { edge: /edge/i, chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i };

            for (var key in browsers) {
                if (browsers[key].test(userAgent)) {
                    return key;
                }
            }
            return "unknown";
        }

        function emailPdf() {

            var mailDto = {};
            mailDto.Recipients = [];
            if (vm.mailTo) {
                if (vm.mailTo.indexOf('@') > 0) {
                    if (vm.mailTo.indexOf(',') > 0 && vm.mailTo.indexOf(';') > 0) {
                        common.logger.error("Please use only a comma or a semicolon as seperators.  Do not use a combination of both.")
                        return;
                    }

                    if (vm.mailTo.indexOf(',') > 0) {
                        mailDto.Recipients = vm.mailTo.split(',');
                    }

                    if (vm.mailTo.indexOf(';') > 0) {
                        mailDto.Recipients = vm.mailTo.split(';');
                    }

                    if(mailDto.Recipients.length == 0) {
                        mailDto.Recipients.push(vm.mailTo);
                    }
                }
                else {
                    common.logger.error("You must supply an valid email to send the report to");
                }
            }
            else {
                common.logger.error("You must supply an email to send the report to");
                return;
            }

            var logType = "";

            for(var i = 0; i < vm.logTypes.length; i++) {
                if(vm.logTypes[i].ID == vm.filters.LogTypeId) {
                    logType = vm.logTypes[i].Description;
                    
                    mailDto.HtmlBody = vm.logTypes[i].MessageHtml;
                    break;
                }
            }
            
            mailDto.subject = logType + " from " + moment(vm.filters.fromDate).format("MM/DD/YYYY") + " to " + moment(vm.filters.toDate).format("MM/DD/YYYY");;
            
            var docDefinition = _generatePdf();
            pdfMake.createPdf(docDefinition).getBase64(function (encodedString) {
                
                mailDto.Attachments = [];
                var attach = {};
                attach.Base64Data = encodedString;
                attach.ContentType = "application/pdf";
                attach.FileName = logType + ".pdf";
                mailDto.Attachments.push(attach);
                mailDto.LogTypeId = vm.filters.LogTypeId;

                dataservice.saveItem("api/Mail/SendMessage", mailDto, false, "Message Sent").then(function (response) {
                    vm.mailTo = "";
                    vm.emailShowing = false;
                }, function (error) { });

            });
            
        }

        function showEmail($event) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.emailShowing = true;

        }

        function _generatePdf() {
            var allowCompletions = vm.displayedItems[0].AllowCompletions;

            var cols = [
                { text: "Added By", style: "tableHeader" },
                { text: "Added At", style: "tableHeader" },
                { text: "Entry Title", style: "tableHeader" },
                { text: "Attachment", style: "tableHeader" }
            ];

            if (allowCompletions) {
                cols.push({ text: "Last Completion", style: "tableHeader" });
            }
            
            var bodyObj = [
                cols
            ];

            for (var i = 0; i < vm.displayedItems.length; i++) {
                var item = vm.displayedItems[i];
                var row = [];
                
                row.push({ text: item.UserName, style: "entryRow" });
                row.push({ text: moment(moment.utc(item.DateAddedUtc).toDate()).format("L LT"), style: "entryRow" });
                row.push({ text: item.Entry, style: "entryRow" });
                if (item.HasAttachment) {
                        var cellContent = [];
                        for (var j = 0; j < item.Attachments.length; j++) {
                            if (item.Attachments[j].Base64Data) {
                                cellContent.push({ image: "data:image/png;base64," + item.Attachments[j].Base64Data });
                                cellContent.push({ text: "", margin: [0, 3, 0, 0] });
                            }
                            else {
                                cellContent.push({ text: "Attachment Type not supported in PDF", style: "entryRow" });
                            }
                        }
                        row.push(cellContent);
                   
                }
                else {
                    row.push({ text: "", style: "entryRow" });
                }
                if (allowCompletions) {
                    if (item.LastCompletion) {
                        row.push({ text: item.LastCompletion + "\nby:" + item.CompletedBy + "\nat:" + _utcToLocal(item.CompletedAtUtc), style: "entryRow" });
                    }
                    else {
                        row.push({ text: "", style: "entryRow" });
                    }
                }
                
                bodyObj.push(row);

                var questions = [];
                for (var j = 0; j < item.Questions.length; j++) {
                    var question = item.Questions[j];
                    var questionStack = [];
                    questionStack.push({ text: question.Question, margin: [10, 2, 0, 0], style: "question" })
                    switch (question.AnswerType) {
                        case 1:
                        case 2:
                            questionStack.push({ text: question.Answer ? question.Answer : '', margin: [20, 2, 0, 0], style: "answer" });
                            break;
                        case 5:
                        case 3:
                            questionStack.push({ text: getSingleItemAnswerText(question), margin: [20, 2, 0, 0], style: "answer" });
                            break;
                        case 6:
                            questionStack.push({ text: formatDateTimeAnswer(question.Answer, true), margin: [20, 2, 0, 0], style: "answer" });
                            break;
                        case 7:
                            questionStack.push({ text: formatDateTimeAnswer(question.Answer, false), margin: [20, 2, 0, 0], style: "answer" });
                            break;
                        case 4:
                            for (var ii = 0; ii < question.Items.length; ii++) {
                                var itemText = question.Items[ii].Description;
                                if (question.Items[ii].Selected && item.IncludeEmptyResponses) {
                                    itemText = "X - " + itemText
                                }
                                
                                if (question.Items[ii].Selected || item.IncludeEmptyResponses) {
                                    questionStack.push({ text: itemText, margin: [20, 2, 0, 0], style: "answer" });
                                }
                            }
                            break;
                        case 8:
                            if (question.Answer) {
                                questionStack.push({ image: question.Answer });
                            }
                            break;
                    }
                    questions.push(questionStack);
                }

                var detailRow = [{
                    stack: [questions]
                    , colSpan: cols.length
                }];

                bodyObj.push(detailRow);
            }


            var ws = [100, 125, "*", 250];
            if (allowCompletions) {
                ws.push(100);
            }

            var tableObj = {
                headerRows: 1,
                widths: ws,
                body: bodyObj,
                dontBreakRows: false
            };

            var docHeader = _getFileName('') + " - ";
            docHeader += moment(vm.filters.fromDate).format("MM/DD/YYYY") + " - " + moment(vm.filters.toDate).format("MM/DD/YYYY");
            _logReportName = docHeader + ".pdf";
            var docDefinition = {
                title: 'Log Report',
                header: { text: docHeader, margin: [3, 3, 0, 0] },
                footer: function (currentPage, pageCount) { return { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right', margin: [0, 0, 5, 0] }; },
                pageOrientation: 'landscape',
                content: [
                  {
                      table: tableObj,
                      layout: 'noBorders'
                  }
                ],
                styles: {
                    tableHeader: { fontSize: 16, bold: true },
                    entryRow: { fillColor: '#dedede' },
                    question: { fontSize: 12, bold: true },
                    answer: { italics: true }
                }
            };
            return docDefinition;
        }

      
        function openDatePicker(isStart) {
            if (isStart) {
                vm.dpStatus.fromDateOpen = true;
                vm.dpStatus.toDateOpen = false;
            }
            else {
                vm.dpStatus.fromDateOpen = false;
                vm.dpStatus.toDateOpen = true;
            }

        }

        function showAttachment(item) {
            dataservice.getItems('api/Attachments/GetForParentType/8/' + item.ID).then(function (response) {
                return carouselDialog.display(response.data);
            }, function (error) { });
        }

        function getFilters() {
            return dataservice.getItems('api/LogTypes').then(function (response) {
                var data = response.data;
                var filterd = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].Active) {
                        filterd.push(data[i]);
                    }
                }
                vm.logTypes = filterd;
                return vm.logTypes;
            }, function (error) {
                console.log("Error in getFilters()");
                console.log(error);
            });
        }

        function generate() {
            vm.generated = true;
            vm.filters.fromDateLocalString = moment(vm.filters.fromDate).format("YYYY-MM-DD");
            vm.filters.toDateLocalString = moment(vm.filters.toDate).format("YYYY-MM-DD");

            return dataservice.query('api/DailyLogs/Report', vm.filters).then(function (response) {
                vm.items = response.data;
                return vm.items;
            }, function (error) { });

        }

    }
})();
